import { Icon } from "@dmm-com/rocket-web-ui-library";
import { memo, useState } from "react";
import * as Styled from "./style";
import { useCarouselScroll } from "./use-carousel-scroll";
import type { VideoStageSeasonType } from "~/components/blocks/product/type-guard";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { formatDateToDayOfWeek, formatDateToMD } from "~/util/format-date";

type PerformanceDateListProps = {
  allPerformances: VideoStageSeasonType["allPerformances"];
  filterPerformanceProcessData: ({ performanceDateArgs }: { performanceDateArgs: Date | null }) => void;
};

/** 公演日で絞り込むことができるボタンの一覧を並べるコンポーネント */
export const PerformanceDateList = memo((props: PerformanceDateListProps) => {
  const { allPerformances, filterPerformanceProcessData } = props;

  const [isAllBtnActive, setIsAllBtnActive] = useState(true);
  const [isActiveIndex, setIsActiveIndex] = useState(0);

  const { handleClickByDevice } = useHandleClickByDevice();

  const { ref, isShowPrevButton, isShowNextButton, onLeftBtnClicked, onRightBtnClicked } =
    useCarouselScroll<HTMLDivElement>();

  return (
    <Styled.DivPositionRelative>
      {isShowPrevButton && (
        <Styled.ButtonLeftArrow
          type="button"
          name="prev-button"
          aria-label="prev-button"
          {...handleClickByDevice(() => onLeftBtnClicked())}
        >
          <Icon name="arrowLeft" size="XL" color="GRAY900" />
        </Styled.ButtonLeftArrow>
      )}

      <Styled.DivScrollAreaRoot ref={ref}>
        <Styled.DivFlexContainer>
          {allPerformances.length > 0 ? (
            <Styled.ButtonItem
              type="button"
              isActive={isAllBtnActive}
              aria-selected={isAllBtnActive}
              onClick={() => {
                setIsAllBtnActive(true);
                setIsActiveIndex(0);
                filterPerformanceProcessData({ performanceDateArgs: null });
              }}
            >
              すべて
            </Styled.ButtonItem>
          ) : null}

          {allPerformances.map((item, idx) => (
            <Styled.ButtonItem
              type="button"
              key={idx}
              isActive={isActiveIndex === idx + 1}
              aria-selected={isActiveIndex === idx + 1}
              {...handleClickByDevice(() => {
                setIsAllBtnActive(false);
                setIsActiveIndex(idx + 1);
                filterPerformanceProcessData({ performanceDateArgs: item.performanceDate });
              })}
            >
              <Styled.SpanDayOfWeek>{formatDateToDayOfWeek(item.performanceDate)}</Styled.SpanDayOfWeek>
              <Styled.SpanDate>{formatDateToMD(item.performanceDate)}</Styled.SpanDate>
            </Styled.ButtonItem>
          ))}
        </Styled.DivFlexContainer>
      </Styled.DivScrollAreaRoot>

      {isShowNextButton && (
        <Styled.ButtonRightArrow
          type="button"
          name="next-button"
          aria-label="next-button"
          {...handleClickByDevice(() => onRightBtnClicked())}
        >
          <Icon name="arrowRight" size="XL" color="GRAY900" />
        </Styled.ButtonRightArrow>
      )}
    </Styled.DivPositionRelative>
  );
});

PerformanceDateList.displayName = "PerformanceDateList";
